import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { StrictMode, Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Theme } from '@arc-ui/components';
import { EEBFooter, EEBHeader, ErrorBoundary } from './components';
import AdobeLaunchHelmet from './utils/adobe-launch-script';

import './App.css';
import { ROUTES } from './constants';
import { EnvContextProvider } from './contexts/EnvironmentContext';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

ReactDOM.createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter basename={ROUTES.HOME}>
      <HelmetProvider>
        <Suspense fallback={<div></div>}>
          <EnvContextProvider>
            <AdobeLaunchHelmet />
            <Theme theme="ee">
              <ErrorBoundary>
                <EEBHeader />
                <App />
                <EEBFooter />
              </ErrorBoundary>
            </Theme>
          </EnvContextProvider>
        </Suspense>
      </HelmetProvider>
    </BrowserRouter>
  </StrictMode>,
);
